// extracted by mini-css-extract-plugin
export default {"internet-tele__txt":"news_internet-tele__txt__JXjk4","color-red":"news_color-red__KHNI7","internet-tele__txt_title":"news_internet-tele__txt_title__5QRPN"};